import { useCallback, useMemo } from "react";
import { Box, Grid, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import StorefrontIcon from '@mui/icons-material/Storefront';
import GradingIcon from '@mui/icons-material/Grading';
import PercentIcon from '@mui/icons-material/Percent';


interface IPropsCustomersVisitControl {
	dataReport: any[];
}
const CustomersVisitControl = (props: IPropsCustomersVisitControl) => {
	const { dataReport } = props;

	const { clientsVisit, allsClients } = useMemo(() => {
		return dataReport.reduce((acc, curr) => {
			acc.clientsVisit += curr.visitClient;
			acc.allsClients += curr.allsClients;
			return acc;
		}, { clientsVisit: 0, allsClients: 0 });
	}, [dataReport]);

	const getVisitPercentage = useCallback((allsClients: number, visitClients: number) => {
		if (allsClients === 0) return 0;

		return (Math.round(((visitClients / allsClients) * 100) * 100) / 100).toFixed(2);
	}, [])

	const getColor = useCallback((percentage: number) => {
		if (percentage >= 75) return "#4caf50";
		if (percentage >= 40) return "#ff9800";
		return "#f55a4fff";
	}, []);

	return (
		<>
			<Grid container spacing={2} mb={2} px={2}>
				<Grid size={12} mb={2}>
					<Typography variant="h6" fontWeight="bold">
						Control de Visitas de Clientes por Vendedor
					</Typography>
				</Grid>
				<Grid size={4}>
					<Paper elevation={3} sx={{ padding: 2, mb: 2, backgroundColor: "#f5f5f5", display: 'flex', alignItems: 'center', gap: 2 }}>
						<StorefrontIcon sx={{ fontSize: 40, color: "#183555" }} />
						<Box>
							<Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#183555" }}>
								Total de clientes
							</Typography>
							<Typography variant="h4" fontWeight="bold" sx={{ color: "#183555" }}>{allsClients}</Typography>
						</Box>
					</Paper>
				</Grid>
				<Grid size={4}>
					<Paper elevation={3} sx={{ padding: 2, mb: 2, backgroundColor: "#f5f5f5", display: 'flex', alignItems: 'center', gap: 2 }}>
						<GradingIcon sx={{ fontSize: 40, color: "#183555" }} />
						<Box>
							<Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#183555" }}>
								Total de visitas
							</Typography>
							<Typography variant="h4" fontWeight="bold" sx={{ color: "#183555" }}>{clientsVisit}</Typography>
						</Box>
					</Paper>
				</Grid>
				<Grid size={4}>
					<Paper elevation={3} sx={{ padding: 2, mb: 2, backgroundColor: "#f5f5f5", display: 'flex', alignItems: 'center', gap: 2 }}>
						<PercentIcon sx={{ fontSize: 40, color: "#183555" }} />
						<Box>
							<Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#183555" }}>
								Porcentaje de efectividad
							</Typography>
							<Typography variant="h4" fontWeight="bold" sx={{ color: "#183555" }}>{getVisitPercentage(allsClients, clientsVisit)}%</Typography>
						</Box>
					</Paper>
				</Grid>
			</Grid>
			<TableContainer sx={{ maxHeight: 600, px: 2 }}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
					<TableHead>
						<TableRow sx={{ backgroundColor: "#183555" }}>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Vendedor</Typography>
							</TableCell>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Ruta</Typography>
							</TableCell>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Código Vendedor</Typography>
							</TableCell>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Clientes Visitados</Typography>
							</TableCell>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Clientes Totales</Typography>
							</TableCell>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">% Visitas</Typography>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{
							dataReport.map((order, index) => {
								const valuePercentage = getVisitPercentage(order.allsClients, order.visitClient);
								return (
									<TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: "#f5f5f5" } }}>
										<TableCell>
											<Typography variant="body2" fontWeight="bold">{order.vendorName}</Typography>
											<Typography variant="caption" color="text.secondary">{order.email}</Typography>
										</TableCell>
										<TableCell>{order.router}</TableCell>
										<TableCell>{order.salesPersonCode}</TableCell>
										<TableCell>{order.visitClient}</TableCell>
										<TableCell>{order.allsClients}</TableCell>
										<TableCell>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between' }}>
												<LinearProgress
													variant="determinate"
													value={Number(valuePercentage)}
													sx={{
														flex: 1,
														minWidth: 100,
														backgroundColor: "#e0e0e0",
														"& .MuiLinearProgress-bar": {
															backgroundColor: getColor(Number(valuePercentage)),
														}
													}}
												/>
												<Typography fontWeight="bold" sx={{ color: getColor(Number(valuePercentage)), minWidth: 50, textAlign: 'right' }}>
													{valuePercentage}%
												</Typography>
											</Box>
										</TableCell>
									</TableRow>
								)
							})
						}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};
export default CustomersVisitControl;